module.exports = __webpack_public_path__ + "static/media/Bocadomalanga.d88279da.jpg";